import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Instructor } from './model/instructor.model';
import { ErrorCode } from '../../models/error-code.model';

export const InstructorApiActions = createActionGroup({
    source: 'API/Instructor',
    events: {
        'load instructors': emptyProps()
    }
});

export const InstructorActions = createActionGroup({
    source: 'Instructor',
    events: {
        'load instructors success': props<{ instructors: Instructor[] }>(),
        'load instructors failure': props<{ error: ErrorCode }>()
    }
});
